<span ng-bind="vm.name"></span>
